import {SearchQueryParams} from '../../models/search-query-params.model';
import {Transcoder, TranscoderSimple} from '../../models/transcoder.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace TranscoderActions {
    export class GetListPage {
        static readonly type = 'TranscoderActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class Add {
        static readonly type = 'TranscoderActions.TranscoderAdd';

        constructor(public data: Transcoder) {
        }
    }

    export class Update {
        static readonly type = 'TranscoderActions.TranscoderEdit';

        constructor(public data: Transcoder) {
        }
    }

    export class FormFailure {
        static readonly type = 'TranscoderActions.TranscoderFormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class FieldList {
        static readonly type = 'TranscoderActions.FieldList';

        constructor(public readonly brand: string) {
        }
    }

    export class GetById {
        static readonly type = 'TranscoderActions.GetById';

        constructor(public id: number) {
        }
    }

    export class Delete {
        static readonly type = 'TranscoderActions.Delete';

        constructor(public item: Transcoder) {
        }
    }

    export class SearchIndex {
        static readonly type = 'TranscoderActions.SearchIndex';

        constructor(public index: string) {
        }
    }

    export class SetFieldList {
        static readonly type = 'TranscoderActions.SetFieldList';

        constructor(public fieldList: TranscoderSimple[]) {
        }
    }
}
